import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TheOlfactoryExperience() {
  return <section data-section-id="229926" id="the-pinnacle-of-peptide-purity" className="bg-background text-foreground relative overflow-hidden min-h-[90vh] flex items-center py-20">
      {}
      <style>{`
        @keyframes slowPan {
          0% { transform: scale(1.05) translate(0, 0); }
          50% { transform: scale(1.1) translate(-2%, 2%); }
          100% { transform: scale(1.05) translate(0, 0); }
        }
        .animate-slow-pan {
          animation: slowPan 60s ease-in-out infinite;
        }
      `}</style>

      {}
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none opacity-10">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655791/img/molecular_gold_void.png)] bg-cover bg-center animate-slow-pan mix-blend-screen" />
      </div>

      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="flex flex-col items-start max-w-2xl">
            <h1 className="font-default text-5xl md:text-6xl lg:text-7xl font-bold mb-6 text-primary bg-clip-text text-transparent bg-gradient-to-b from-primary to-primary/60 drop-shadow-lg tracking-tighter">
              THE PINNACLE OF PEPTIDE PURITY
            </h1>
            
            <p className="font-default text-lg md:text-xl text-muted-foreground mb-10 leading-relaxed">
              Elite-grade compounds for the world's most rigorous research environments. Aurelian Helix delivers uncompromising quality for institutional and laboratory excellence.
            </p>
            
            <Button asChild variant="outline" size="lg" className="border border-primary text-primary hover:bg-primary hover:text-primary-foreground hover:shadow-[0_0_20px_rgba(212,175,55,0.5)] transition-all duration-500 bg-transparent rounded-none px-8 py-6 text-base tracking-widest uppercase font-bold">
              <Link to="/ShopPage">
                Explore the Collection
              </Link>
            </Button>

            <p className="font-mono text-[10px] text-muted-foreground/50 mt-8 uppercase tracking-widest">
              For Research Use Only. Not for human consumption.
            </p>
          </div>

          {}
          <div className="relative w-full aspect-[4/5] lg:aspect-auto lg:h-[700px] shadow-2xl">
            <div className="absolute inset-0 bg-gradient-to-tr from-background/60 via-transparent to-primary/10 z-10 mix-blend-overlay pointer-events-none" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655791/img/premium_peptide_vial_research.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655791/img/premium_peptide_vial_research.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655791/img/premium_peptide_vial_research.png-wvc-sizes" alt="Elite grade research peptide vial in a sterile laboratory setting" className="w-full h-full object-cover rounded-none grayscale contrast-125" loading="lazy" decoding="async" />
          </div>

        </div>
      </div>
    </section>;
}